import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import {
  Avatar,
  Box,
  Button,
  Card,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import { BASE_URL, postData } from "../Utils/Baseurl";
import { useLoading } from "../../context/loadingcontext";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useNavigate } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import noData from "../../assest/NoDataImage.png";
import ChatBot from "../chatbot";
import MaterialSelect from "../../components/MaterialSelect";

const Portfolio = () => {
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const [project, setProject] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [task, setTask] = useState({
    label: "All",
    value: "All",
  });
  const [projectStatus, setProjectStatus] = useState({
    label: "All",
    value: "All",
  });
  const [projectType, setProjectType] = useState([]);
  const [status, setStaus] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const open = Boolean(anchorEl);
  const [chatBotStatus, setChatBotStatus] = useState(false);
  const [suggestion, setSuggestion] = useState("");

  useEffect(() => {
    fetchProjectStatus();
    fetchProjectType();
  }, []);

  useEffect(() => {
    fetchProjectData();
    fetchChatList();
  }, [projectStatus, task]);
  const fetchProjectType = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${BASE_URL}api/ProjectType/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();

      const projectType = data.data.map((item) => ({
        value: item.id,
        label: item?.projecttype,
      }));
      setProjectType([{ label: "All", value: null }, ...projectType]);
    } catch (error) {
      console.error("Error fetching team members:", error);
    }
  };
  const fetchProjectStatus = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${BASE_URL}api/Status/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();

      const status = data.data.map((item) => ({
        value: item.id,
        label: item.status,
      }));
      setStaus([{ label: "All", value: null }, ...status]);
    } catch (error) {
      console.error("Error fetching team members:", error);
    }
  };
  const fetchChatList = async () => {
    setCirleLoading(true);
    try {
      const res = await postData("ai/ManagerProjectAnalysis/");

      setChatBotStatus(true);
      setSuggestion(res?.analysis || res?.message);
    } catch (error) {
      setSuggestion("");
      setChatBotStatus(false);
    } finally {
      setCirleLoading(false);
    }
  };

  const fetchProjectData = async () => {
    setCirleLoading(true);
    try {
      const formdata = {
        project_type: task?.label === "All" ? "" : task?.label,
        status: projectStatus?.label === "All" ? "" : projectStatus?.label,
      };
      const response = await postData("api/project/filter/", formdata);

      const data = response?.data;

      setProject(data);
    } catch (error) {
      console.log(error, "error");
    } finally {
      setCirleLoading(false);
    }
  };

  const handleClick = (event, projectId) => {
    setAnchorEl(event.currentTarget);
    setSelectedProjectId(projectId);
  };

  const handleClose = (action) => {
    if (action && selectedProjectId) {
      if (action === "View") {
        navigate(`/project-list/view-protfolio`, {
          state: { projectId: selectedProjectId },
        });
      } else if (action === "Edit") {
        navigate("/project-list/edit-project", {
          state: { projectId: selectedProjectId },
        });
      } else if (action === "Delete") {
        // projectDeleteData();
      }
    }
    setAnchorEl(null);
    setSelectedProjectId(null);
  };

  const truncate = (desc) =>
    desc?.length > 25 ? `${desc.substring(0, 28)}...` : desc;

  return (
    <DashboardLayout>
      <div
        style={{
          display: "flex",
          width: "90%",
          justifyContent: "space-between",
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          p={1}
          mb={2}
        >
          <Stack direction="column" spacing={0}>
            <MaterialTypography variant="h5" fontWeight="bold" color="dark">
              Portfolio
            </MaterialTypography>
            <MaterialTypography variant="caption" color="text">
              You can view the portfolio here.
            </MaterialTypography>
          </Stack>
        </Stack>
        <div>
          <MaterialTypography variant="caption" color="text">
            Project Type
          </MaterialTypography>
          <MaterialSelect
            name="projectTask"
            value={task}
            onChange={(e) => setTask(e)}
            options={projectType}
            customStyles={{ optionPadding: 20 }}
          />
        </div>
        <div>
          <MaterialTypography variant="caption" color="text">
            Project Status
          </MaterialTypography>
          <MaterialSelect
            name="projectTask"
            value={projectStatus}
            onChange={(e) => setProjectStatus(e)}
            options={status}
          />
        </div>
      </div>

      {chatBotStatus && (
        <div className="chatbox-container">
          <ChatBot
            suggestionText={suggestion}
            style={{ marginTop: "-100px", marginRight: "0px" }}
          />
        </div>
      )}

      {project.length === 0 ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "60vh",
            textAlign: "center",
          }}
        >
          <img
            src={noData}
            alt="No Projects"
            style={{ width: "250px", height: "25    0px" }}
          />
        </Box>
      ) : (
        <Grid container spacing={2} sx={{ mt: 2, p: 1 }}>
          {project.map((item) => (
            <Grid size={{ xs: 12, sm: 3, md: 3 }} key={item.project_id}>
              <Card sx={{ p: 1, maxHeight: 240, zIndex: 0 }}>

                <Box sx={{ position: "absolute", top: 3, right: 3 }}>
                  <IconButton
                    onClick={(event) => handleClick(event, item.project_id)}
                    size="small"
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    anchorEl={anchorEl}
                    open={open && selectedProjectId === item.project_id}
                    onClose={() => handleClose("")}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  >
                    <MenuItem onClick={() => handleClose("Edit")}>
                      Edit
                    </MenuItem>
                    <MenuItem onClick={() => handleClose("View")}>
                      View
                    </MenuItem>
                    {/* <MenuItem onClick={() => handleClose("Delete")}>
                                            Delete
                                        </MenuItem> */}
                  </Menu>
                </Box>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12, md: 12 }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Avatar
                        alt="Remy Sharp"
                        src={item.project_logo}
                        sx={{
                          width: 40,
                          height: 40,
                          "& img": {
                            objectFit: "cover",
                            width: "100%",
                            height: "100%",
                          },
                        }}
                      />
                      <Stack direction="column" spacing={0}>
                        <MaterialTypography
                          variant="h6"
                          fontWeight="bold"
                          color="dark"
                          sx={{ fontSize: "12px" }}
                        >
                          {item.project_name}
                        </MaterialTypography>
                        <MaterialTypography
                          variant="caption"
                          color="text"
                          sx={{ fontSize: "10px" }}
                        >
                          {item.project_code}
                        </MaterialTypography>
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container spacing={2} mt={1}>
                  <Grid size={{ xs: 12, md: 12 }}>
                    <MaterialTypography
                      variant="body2"
                      color="text"
                      sx={{ fontSize: "10px" }}
                    >
                      {truncate(item.description)}
                    </MaterialTypography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} mt={1}>
                  <Grid size={{ xs: 12, md: 12 }}>
                    <Stack direction="row" spacing={1}>
                      <Avatar
                        alt="Remy Sharp"
                        src={item.manager_profile}
                        sx={{
                          width: 30,
                          height: 30,
                          "& img": {
                            objectFit: "cover",
                            width: "100%",
                            height: "100%",
                          },
                        }}
                      />
                      <Stack direction="column" spacing={0}>
                        <MaterialTypography
                          variant="h6"
                          fontWeight="bold"
                          color="text"
                          sx={{ fontSize: "10px" }}
                        >
                          {item.manager}
                        </MaterialTypography>
                        <MaterialTypography
                          variant="h6"
                          fontWeight="bold"
                          color="text"
                          sx={{ fontSize: "10px" }}
                        >
                          Project Manager
                        </MaterialTypography>
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container spacing={2} mt={1}>
                  <Grid size={{ xs: 6, lg: 6 }}>
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography
                        variant="h6"
                        fontWeight="bold"
                        color="text"
                        sx={{ fontSize: "10px" }}
                      >
                        Start Date
                      </MaterialTypography>
                      <MaterialTypography
                        variant="h6"
                        fontWeight="bold"
                        color="text"
                        sx={{ fontSize: "10px" }}
                      >
                        {item.start_date}
                      </MaterialTypography>
                    </Stack>
                  </Grid>
                  <Grid
                    size={{ xs: 6, lg: 6 }}
                    sx={{ display: "flex", flexDirection: "row-reverse" }}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography
                        variant="h6"
                        fontWeight="bold"
                        color="text"
                        sx={{ fontSize: "10px" }}
                      >
                        Live Date
                      </MaterialTypography>
                      <MaterialTypography
                        variant="h6"
                        fontWeight="bold"
                        color="text"
                        sx={{
                          fontSize: "10px",
                          color:
                            item.days_left < 30 && item.completion_percent < 50
                              ? "red"
                              : item.days_left < 5 &&
                                item.completion_percent < 80
                                ? "orange"
                                : "green",
                          animation: "blinker 3s linear infinite",
                          "@keyframes blinker": {
                            "50%": {
                              opacity: 0,
                            },
                          },
                        }}
                      >
                        {item.end_date}
                      </MaterialTypography>
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container spacing={1} mt={1}>
                  <Grid size={{ xs: 6, lg: 6 }}>
                    <Stack direction="row" spacing={0} alignItems="center">
                      <CalendarMonthIcon
                        sx={{ color: "#00C853", fontSize: 16 }}
                      />
                      <MaterialTypography
                        variant="body2"
                        color="text"
                        sx={{ fontSize: "10px" }}
                      >
                        {item.days_left} days left
                      </MaterialTypography>
                    </Stack>
                  </Grid>
                  <Grid
                    size={{ xs: 6 }}
                    sx={{ display: "flex", flexDirection: "row-reverse" }}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography
                        variant="body2"
                        color="text"
                        sx={{ fontSize: "10px" }}
                      >
                        Completed tasks: {item.completion_percent}%
                      </MaterialTypography>
                    </Stack>
                  </Grid>
                </Grid>
                {item?.status && (
                  <Box
                    sx={{
                      width: "100px",
                      height: "100px",
                      overflow: "hidden",
                      position: "absolute",
                      top: 0,
                      right: 0,
                      zIndex: -1,
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        fontSize: "10px",
                        fontWeight: "bold",
                        color: "#fff",
                        textAlign: "center",
                        position: "absolute",
                        width: "140px",
                        top: "25px",
                        right: "-40px",
                        backgroundColor: item?.color || "orange",
                        padding: "2px 0",
                        transform: "rotate(45deg)",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                      }}
                    >
                      {item?.status}
                    </Box>
                  </Box>
                )}
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </DashboardLayout>
  );
};

export default Portfolio;
